import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { money } from "../lib/api";
import { useCart } from "../context/CartContext";
import { Plus } from "lucide-react";

export default function ProductCard({ product, index = 0 }) {
  const { addItem } = useCart();

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay: (index % 4) * 0.06, ease: [0.22, 1, 0.36, 1] }}
      className="group"
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/product/${product.slug}`} className="block">
        <div className="relative aspect-square overflow-hidden bg-gradient-to-br from-[#161616] to-[#080808] border border-[#27272a] card-glow transition-shadow duration-300">
          <img
            src={product.images?.[0]}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-contain p-6 transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
          {!product.in_stock && (
            <span className="absolute top-3 left-3 bg-black/80 text-zinc-300 text-[10px] uppercase tracking-widest px-2 py-1 border border-[#27272a]">
              Backorder
            </span>
          )}
          {product.category === "tires" ? (
            <span
              data-testid={`select-size-${product.slug}`}
              className="absolute bottom-3 right-3 h-10 px-3 flex items-center justify-center gap-1 bttf-gradient text-black text-xs font-semibold uppercase opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300"
            >
              Pick Size
            </span>
          ) : (
            <button
              data-testid={`quick-add-${product.slug}`}
              onClick={(e) => {
                e.preventDefault();
                addItem(product);
              }}
              className="absolute bottom-3 right-3 h-10 w-10 flex items-center justify-center bttf-gradient text-black opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300"
              aria-label="Quick add"
            >
              <Plus size={20} />
            </button>
          )}
        </div>
      </Link>
      <div className="pt-4">
        <div className="text-[11px] uppercase tracking-[0.18em] text-[#00f0ff]">{product.brand}</div>
        <Link to={`/product/${product.slug}`}>
          <h3 className="font-display text-xl mt-1 leading-tight group-hover:text-[#00f0ff] transition-colors">
            {product.name}
          </h3>
        </Link>
        <div className="flex items-center justify-between mt-1">
          <span className="text-zinc-400 text-xs">{product.sub_category}</span>
          <span className="text-white font-bold">{product.category === "tires" ? `From ${money(product.price)}` : money(product.price)}</span>
        </div>
      </div>
    </motion.div>
  );
}
